/* Interacciones globales. Todo es mejora progresiva: sin JavaScript la tienda funciona igual.
   1. Acordeones (<details class="pk-acc">): uno abierto por grupo y apertura animada.
   2. Secciones que entran con un fundido suave al aparecer en pantalla.
   3. Barra de progreso de lectura en el header.
   4. Llegada animada a un ancla (/#pk-fit) desde otra página. */
(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const EASE = 'cubic-bezier(.2,.7,.2,1)';

  /* 0 · Test A/B de portadas: zoom de la variante vista + registro del evento */
  document.querySelectorAll('[data-ab-zoom]').forEach((a) => {
    if (document.documentElement.getAttribute('data-ab-everest') === 'b') a.href = a.dataset.abZoom;
  });
  const abKeys = [...new Set([...document.querySelectorAll('[data-ab]')].map((el) => el.dataset.ab))];
  abKeys.forEach((k) => {
    const v = document.documentElement.getAttribute('data-ab-' + k) || 'a';
    const label = { everest: { a: 'sw4', b: 'jeep' } }[k]?.[v] || v;
    (window.dataLayer = window.dataLayer || []).push({ event: 'pk_ab', test: 'portada_' + k, variant: label });
    try { window.Shopify?.analytics?.publish?.('pk_ab', { test: 'portada_' + k, variant: label }); } catch (e) { /* sin analytics */ }
  });

  /* 1 · Acordeones */
  const animate = (d, open) => {
    const summary = d.querySelector('summary');
    if (reduced || !d.animate) { d.open = open; return; }
    d._anim?.cancel();
    const from = d.offsetHeight;
    if (open) d.open = true;
    const to = open ? d.scrollHeight : summary.offsetHeight;
    d.classList.toggle('is-closing', !open);
    d.style.overflow = 'hidden';
    const anim = d.animate({ height: [`${from}px`, `${to}px`] }, { duration: 380, easing: EASE });
    d._anim = anim;
    anim.onfinish = () => { d._anim = null; d.style.overflow = ''; d.classList.remove('is-closing'); if (!open) d.open = false; };
    anim.oncancel = () => { d._anim = null; d.style.overflow = ''; };
  };
  document.addEventListener('click', (e) => {
    const summary = e.target.closest('details.pk-acc > summary');
    if (!summary) return;
    e.preventDefault();
    const d = summary.parentElement;
    const opening = !d.open || d.classList.contains('is-closing');
    if (opening) d.parentElement.querySelectorAll(':scope > details.pk-acc[open]').forEach((o) => { if (o !== d) animate(o, false); });
    animate(d, opening);
  });

  /* 2 · Secciones que entran al aparecer */
  if (!reduced && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => entries.forEach((en) => {
      if (!en.isIntersecting) return;
      const el = en.target;
      el.classList.add('is-in');
      io.unobserve(el);
      setTimeout(() => el.classList.remove('pk-rv', 'is-in'), 1000);
    }), { rootMargin: '0px 0px -4% 0px', threshold: 0.01 });
    document.querySelectorAll('#pk-main > .shopify-section').forEach((s, i) => {
      if (i === 0 || s.getBoundingClientRect().top < innerHeight * 0.88) return;
      s.classList.add('pk-rv');
      io.observe(s);
    });
  }

  /* 3 · Barra de progreso */
  const bar = document.querySelector('[data-pk-progress]');
  if (bar) {
    let raf = 0;
    const update = () => {
      raf = 0;
      const max = document.documentElement.scrollHeight - innerHeight;
      bar.style.transform = `scaleX(${max > 0 ? Math.min(1, Math.max(0, scrollY / max)) : 0})`;
    };
    addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(update); }, { passive: true });
    addEventListener('resize', update);
    update();
  }

  /* 4 · Enlaces a una sección de otra página (/#pk-fit desde una ficha):
     se navega sin el ancla, la página nueva entra con la transición y después baja suave hasta la sección. */
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[href*="#"]');
    if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || a.target === '_blank') return;
    const url = new URL(a.href, location.href);
    if (url.origin !== location.origin || !url.hash || url.pathname === location.pathname) return;
    e.preventDefault();
    sessionStorage.setItem('pk-to', decodeURIComponent(url.hash.slice(1)));
    url.hash = '';
    location.href = url.href;
  });
  const to = sessionStorage.getItem('pk-to');
  if (to) {
    sessionStorage.removeItem('pk-to');
    const go = () => {
      const target = document.getElementById(to);
      if (target) setTimeout(() => target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' }), reduced ? 0 : 380);
    };
    if (document.readyState === 'complete') go(); else addEventListener('load', go, { once: true });
  }
  /* ── Envío de carpas (snippet pk-ship-quote): AMBA bonificado, resto se cotiza por WhatsApp.
     Eventos delegados: la ficha se reemplaza entera al cambiar de variante. ── */
  const shipLink = (box) => {
    const prov = box.querySelector('[data-ship-prov]');
    const city = box.querySelector('[data-ship-city]').value.trim();
    const where = city ? `${city} (${prov.value})` : prov.value;
    const text = `Hola! Quiero cotizar el envío de la ${box.dataset.product} a ${where}. ${box.dataset.url}`;
    return `https://wa.me/${box.dataset.wa}?text=${encodeURIComponent(text)}`;
  };
  document.addEventListener('change', (e) => {
    const prov = e.target.closest('[data-ship-prov]');
    if (!prov) return;
    const box = prov.closest('[data-pk-ship]');
    const amba = prov.value === 'amba';
    box.querySelector('[data-ship-amba]').hidden = !amba;
    box.querySelector('[data-ship-quote]').hidden = amba || !prov.value;
    try { sessionStorage.setItem('pk-ship-prov', prov.value); } catch (_) {}
  });
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-ship-wa]');
    if (!btn) return;
    const box = btn.closest('[data-pk-ship]');
    const input = box.querySelector('[data-ship-city]');
    const hint = box.querySelector('[data-ship-hint]');
    if (!input.value.trim()) {
      e.preventDefault();
      input.setAttribute('aria-invalid', 'true');
      hint.textContent = 'Escribí tu localidad o código postal para cotizar.';
      hint.classList.add('is-error');
      input.focus();
      return;
    }
    btn.href = shipLink(box);
  });
  document.addEventListener('input', (e) => {
    const input = e.target.closest('[data-ship-city]');
    if (!input || !input.hasAttribute('aria-invalid')) return;
    input.removeAttribute('aria-invalid');
    const hint = input.closest('[data-pk-ship]').querySelector('[data-ship-hint]');
    hint.textContent = 'Te respondemos con el costo y la sucursal más cercana.';
    hint.classList.remove('is-error');
  });
  // recordar la provincia elegida (también tras cambiar de color, que redibuja la ficha)
  const restoreShip = () => {
    let saved = '';
    try { saved = sessionStorage.getItem('pk-ship-prov') || ''; } catch (_) {}
    document.querySelectorAll('[data-ship-prov]').forEach((sel) => {
      if (!saved || sel.value === saved) return;
      sel.value = saved;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
    });
  };
  restoreShip();
  document.addEventListener('pk:product-updated', restoreShip);
})();
